export default "__VITE_ASSET__BaO_$Qlp__"